import { Store } from "./store";

export class VenuePayDevicePreference {
	venueKey: number;

	venue: Store;

	tip1: number;

	tip2: number;

	tip3: number;

	tipDollarThreshold: number;

	tipDollar1: number;
	tipDollar2: number;
	tipDollar3: number;

	showSurvey: boolean;

	serverPay: boolean;

	canvasSort: number;

	defaultEmployeeId: number;

	checkListSyncInterval: number;

	accessCodeLength: number;

	promptTip: boolean;
	displayTipSuggestions: boolean;
	printedReceiptFooter: string;
	printCreditVoucher: boolean;
	printedReceiptLogoS3key: string;

	public constructor(init?: Partial<VenuePayDevicePreference>) {
		Object.assign(this, init);
	}
}
